var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.2441L0 5.99414L5.25 0.744141L6.475 2.01289L3.36875 5.11914H14V6.86914H3.36875L6.475 9.97539L5.25 11.2441Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftAlt);
export default __webpack_public_path__ + "static/media/arrow_left_alt.8b3e650732f16dd16be6e1e48414157b.svg";
export { ForwardRef as ReactComponent };